// core/interceptors/cache/cache.interceptor.ts
import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpCacheService } from '@billingServices/http-cache/http-cache.service';

export const cacheInterceptor: HttpInterceptorFn = (req, next) => {
  const cacheService = inject(HttpCacheService);
  const isSave = req.headers.get('cache');

  if (req.method !== 'GET') {
    cacheService.invalidateCache();
    return next(req);
  }
  const cachedResponse = cacheService.get(req.url);
  if (cachedResponse && isSave === 'true') {
    return of(cachedResponse);
  }
  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && isSave === 'true') {
        cacheService.put(req.url, event);
      }
    })
  );
};
